import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgFileOutline = function SvgFileOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3.5C6.05964 3.5 5.5 4.05964 5.5 4.75V19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H17.25C17.9404 20.5 18.5 19.9404 18.5 19.25V10.0784C18.5 10.0522 18.4992 10.026 18.4975 10H14.75C13.2312 10 12 8.76878 12 7.25V3.50246C11.974 3.50082 11.9478 3.5 11.9216 3.5H6.75ZM13.5 4.56065L17.4393 8.5H14.75C14.0596 8.5 13.5 7.94036 13.5 7.25V4.56065ZM19.1945 8.13387C19.7103 8.64961 20 9.34908 20 10.0784V19.25C20 20.7688 18.7688 22 17.25 22H6.75C5.23122 22 4 20.7688 4 19.25V4.75C4 3.23122 5.23122 2 6.75 2H11.9216C12.6509 2 13.3504 2.28974 13.8661 2.80545L13.8661 2.80546L19.1945 8.13387Z"
  })));
};

export { SvgFileOutline as ReactComponent };
//# sourceMappingURL=file-outline.svg.js.map
